<template>
  <div class="box-crm">
    <Navbar />
    <div class="crm">
      <b-container class="text-left">
        <b-row>
          <b-col lg="10">
            <vue-good-table
              ref="table-data-crm"
              class="table-crm"
              :columns="columns"
              :rows="row"
              :search-options="{enabled: true}"
              :pagination-options="{
                enabled: true,
                mode: 'records',
                perPage: 10,
                position: 'bottom',
                dropdownAllowAll: false,
                setCurrentPage: 1,
                nextLabel: 'ถัดไป',
                prevLabel: 'ก่อนหน้า',
                rowsPerPageLabel: 'จำนวนข้อมูลต่อหน้า',
                ofLabel: 'จาก',
                pageLabel: 'page',
                allLabel: 'All',
                }"
            >
              <div slot="table-actions">
                <b-button
                  v-if="$session.get('role') === 'Admin'"
                  size="sm"
                  @click="showManageCust"
                  style="margin-right:10px; background-color:#005a7c"
                >
                  <font-awesome-icon icon="cog" />&nbsp;ตั้งค่า
                </b-button>
              </div>
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'tool'">
                  <b-button
                    v-if="props.row.fullname == null"
                    size="sm"
                    style="margin-right:5px; background-color:#005a7c"
                  >
                    <font-awesome-icon icon="user-plus" @click="addFollwer(props.row, 'add')" />&nbsp;
                  </b-button>
                  <b-button
                    v-if="props.row.fullname != null"
                    size="sm"
                    style="margin-right:5px; background-color:#005a7c"
                  >
                    <font-awesome-icon icon="edit" @click="viewCRM(props.row)" />&nbsp;
                  </b-button>
                  <b-button
                    v-if="props.row.fullname != null"
                    size="sm"
                    style="margin-right:5px; background-color:#005a7c"
                  >
                    <font-awesome-icon icon="eye" @click="viewOnlyCRM(props.row)" />&nbsp;
                  </b-button>
                </span>
              </template>
            </vue-good-table>
          </b-col>
          <b-col lg="2">
            <b-row>
              <b-col>
                <b-row class="head-search">
                  <b-col lg="12">
                    <h4>ค้นหา</h4>
                  </b-col>
                </b-row>
                <b-row class="content-search">
                  <b-col lg="12" md="6" class="mb-2">
                    วันที่:
                    <div class="input-group">
                      <b-form-datepicker size="sm" v-model="search.start_date" locale="th"></b-form-datepicker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button
                            class="btnsearch"
                            style="width:100%"
                            size="sm"
                            @click="search.start_date = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="12" md="6" class="mb-2">
                    ถึง:
                    <div class="input-group">
                      <b-form-datepicker size="sm" v-model="search.end_date" locale="th"></b-form-datepicker>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button
                            class="btnsearch"
                            style="width:100%"
                            size="sm"
                            @click="search.end_date = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="12" class="space mt-1 mb-2">
                    <b-button class="btnsearch" style="width:100%" size="sm" @click="searchFn">
                      <font-awesome-icon icon="search" />
                    </b-button>
                  </b-col>
                  <b-col lg="12" md="4">
                    ผู้รับผิดชอบ:
                    <div class="input-group mb-3">
                      <b-form-select
                        size="sm"
                        v-model="search.follower"
                        :options="folower_options_search"
                      ></b-form-select>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button
                            class="btnsearch"
                            style="width:100%"
                            size="sm"
                            @click="searchFn"
                          >
                            <font-awesome-icon icon="search" />
                          </b-button>
                          <b-button
                            class="btnsearch"
                            style="width:100%"
                            size="sm"
                            @click="search.follower = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="12" md="4">
                    บริษัท/ห้างหุ้นส่วนจำกัด:
                    <div class="input-group mb-3">
                      <b-form-input list="company" size="sm" v-model="search.cust_name"></b-form-input>
                      <datalist id="company">
                        <option
                          v-bind:key="company_name"
                          v-for="company_name in options_company"
                        >{{company_name}}</option>
                      </datalist>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button
                            class="btnsearch"
                            style="width:100%"
                            size="sm"
                            @click="searchFn"
                          >
                            <font-awesome-icon icon="search" />
                          </b-button>
                          <b-button
                            class="btnsearch"
                            style="width:100%"
                            size="sm"
                            @click="search.cust_name = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="12" md="4">
                    รหัสโครงการ:
                    <div class="input-group mb-3">
                      <b-form-input size="sm" v-model="search.projectno"></b-form-input>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button
                            class="btnsearch"
                            style="width:100%"
                            size="sm"
                            @click="searchFn"
                          >
                            <font-awesome-icon icon="search" />
                          </b-button>
                          <b-button
                            class="btnsearch"
                            style="width:100%"
                            size="sm"
                            @click="search.projectno = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                  <b-col lg="12" md="4">
                    ประเภทงาน:
                    <div class="input-group mb-3">
                      <b-form-select size="sm" v-model="search.type" :options="type_options"></b-form-select>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <b-button
                            class="btnsearch"
                            style="width:100%"
                            size="sm"
                            @click="searchFn"
                          >
                            <font-awesome-icon icon="search" />
                          </b-button>
                          <b-button
                            class="btnsearch"
                            style="width:100%"
                            size="sm"
                            @click="search.type = null"
                          >
                            <font-awesome-icon icon="redo-alt" />
                          </b-button>
                        </span>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <Footer />
    <b-modal hide-footer ref="modal-config-crm" title="ตั้งค่า" centered>
      <div>
        <b-tabs content-class="mt-3">
          <b-tab class="tab-add" title="ซ่อนบริษัทที่ต้องการ" active>
            <b-container>
              <b-row>
                <b-col>
                  <div class="input-group">
                    <div class="input-group-append">
                      <span class="input-group-text" style="margin-right:5px;">ค้นหา</span>
                    </div>
                    <b-form-input
                      size="sm"
                      list="company"
                      v-model="company_search_bind"
                      placeholder="ชื่อบริษัท/ห้างหุ้นส่วนจำกัด"
                    ></b-form-input>
                    <datalist id="company">
                      <option
                        v-bind:key="company_name"
                        v-for="company_name in options_company"
                      >{{company_name}}</option>
                    </datalist>
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <b-button
                          class="btnsearch"
                          style="width:100%"
                          @click="search_bind"
                          size="sm"
                        >
                          <font-awesome-icon icon="search" />
                        </b-button>
                      </span>
                    </div>
                  </div>
                  <small>* กรอกชื่อบริษัทที่ต้องการซ่อน หลังจากนั้นให้กดปุ่มค้นหา</small>
                </b-col>
              </b-row>
              <b-row>
                <b-col></b-col>
              </b-row>
              <b-row class="mt-3" v-if="show_table_bind_search">
                <b-col>
                  <vue-good-table
                    :columns="column_select_bind"
                    :rows="row_select_bind"
                    @on-row-click="clickAddListBind"
                  ></vue-good-table>
                </b-col>
              </b-row>
            </b-container>
          </b-tab>
          <b-tab class="tab-list" title="ยกเลิกการซ่อน" @click="getListBind">
            <p class="text-center" v-if="!check">ไม่พบรายการ</p>
            <vue-good-table
              v-if="check"
              :columns="column_list_bind"
              :rows="row_list_bind"
              @on-row-click="clickDeleteListBind"
            ></vue-good-table>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
    <b-modal size="sm" hide-footer ref="modal-msg-add" title="อัพเดทความเคลื่อนไหว" centered>
      <b-container class="text-left">
        <b-row>
          <b-col>
            ข้อความ
            <span class="required">&nbsp;*</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-textarea ref="msg" size="sm" rows="5" v-model="form.msg"></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            สถานะ
            <span class="required">&nbsp;*</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-select :options="status_options" ref="status" v-model="form.status"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            เบอร์โทรศัพท์ลูกค้าที่ติดต่อได้
            <span class="required">&nbsp;*</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-input ref="tel" v-model="form.tel"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="text-center mt-4">
          <b-col>
            <b-button size="sm" variant="danger" @click="closeMsgBox">ยกเลิก</b-button>
            <span class="m-1"></span>
            <b-button size="sm" variant="success" @click="addMsg">บันทึก</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal size="sm" hide-footer ref="modal-msg-edit" title="อัพเดทความเคลื่อนไหว" centered>
      <b-container class="text-left">
        <b-row>
          <b-col>
            ข้อความ
            <span class="required">&nbsp;*</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-textarea size="sm" rows="5" ref="msg-update" v-model="update.msg"></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            สถานะ
            <span class="required">&nbsp;*</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-select :options="status_options" ref="status-update" v-model="update.status"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="text-center mt-4">
          <b-col>
            <b-button size="sm" variant="danger" @click="closeMsgBoxEdit">ยกเลิก</b-button>
            <span class="m-1"></span>
            <b-button size="sm" variant="success" @click="editMsg">บันทึก</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal size="sm" hide-footer ref="modal-follower" title="มอบหมายงาน" centered>
      <b-container class="text-left">
        <b-row>
          <b-col>
            ผู้รับผิดชอบ
            <span class="required">&nbsp;*</span>
            <b-form-select
              class="m-2"
              ref="follower"
              @change="changeSelect(follower)"
              v-model="follower"
              :options="folower_options"
              :select-size="10"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mt-2 text-center">
          <b-col>
            <b-button variant="danger" @click="closeFollwer" size="sm">ปิด</b-button>
            <span class="m-1"></span>
            <b-button variant="success" @click="addFolloewer" size="sm">บันทึก</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal
      size="xl"
      ref="modal-crm-data"
      title="การบริหารลูกค้าสัมพันธ์: CRM"
      centered
      hide-footer
    >
      <b-container class="text-left">
        <b-row>
          <b-col lg="3">
            <b-row class="head-title">
              <b-col>
                <h4 class="title-space-top">ข้อมูลบริษัท</h4>
              </b-col>
            </b-row>
            <b-row class="content-title border-box">
              <b-col lg="12" class="mt-2">บริษัท/ห้างหุ้นส่วน</b-col>
              <b-col lg="12">
                <b-form-textarea rows="2" size="sm" disabled v-model="crm.company_name"></b-form-textarea>
              </b-col>
              <b-col lg="12" class="mt-2">ที่อยู่</b-col>
              <b-col lg="12">
                <b-form-textarea rows="3" size="sm" disabled v-model="crm.address"></b-form-textarea>
              </b-col>
              <b-col lg="12" class="mt-2">เบอร์โทรศัพท์</b-col>
              <b-col lg="12">
                <b-form-input size="sm" disabled v-model="crm.tel"></b-form-input>
              </b-col>
              <b-col lg="12" class="mt-2">Line</b-col>
              <b-col lg="12">
                <b-form-input size="sm" disabled v-model="crm.line"></b-form-input>
              </b-col>
              <b-col lg="12" class="mt-2">Email</b-col>
              <b-col lg="12">
                <b-form-input size="sm" disabled v-model="crm.email"></b-form-input>
              </b-col>
              <b-col lg="12" class="mt-2">เลขประจำตัวผู้เสียภาษี</b-col>
              <b-col lg="12">
                <b-form-input size="sm" disabled v-model="crm.taxno"></b-form-input>
              </b-col>
              <b-col lg="12" class="mt-2 mb-4 text-right">
                <b-button size="sm" variant="warning" style="margin-left:5px;" @click="showRequest">
                  <font-awesome-icon icon="tools" />&nbsp;
                </b-button>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="9">
            <b-row>
              <b-col>
                <b-row class="mb-4">
                  <b-col lg="12" class="head-title">
                    <h4 class="title-space-top">โครงการ</h4>
                  </b-col>
                  <b-col lg="12" class="content-title border-box">
                    <p class="m-3" style="font-size: 14px;">{{crm.project_name}}</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="text-left">
              <b-col>
                <b-row class="mb-4">
                  <b-col lg="12" class="head-title">
                    <h4 class="title-space-top">ความเคลื่อนไหว</h4>
                  </b-col>
                  <b-col lg="12" class="content-title border-box">
                    <vue-custom-scrollbar class="scroll-area" :settings="settings">
                      <b-container class="text-left">
                        <b-row class="mt-4" v-for="(msg, index) in crm_sub_msg" :key="index">
                          <b-col class="mb-2" lg="12" style="color: #005a7c">
                            <b>{{crm_sub_msg[index].create_datetime}}</b>&nbsp;&nbsp;|&nbsp;&nbsp;
                            <b>โดย {{crm_sub_msg[index].fullname}}</b>&nbsp;&nbsp;|&nbsp;&nbsp;
                            <span
                              v-if="crm_sub_msg[index].update_datetime !== null"
                              style="color: black; font-size: 10px;"
                            >(มีการเเก้ไข)</span>
                            <b-button
                              v-if="userSession === crm_sub_msg[index].create_by"
                              size="sm"
                              @click="openEditMsg(crm_sub_msg[index])"
                              style="margin-left:5px; background-color:#005a7c"
                            >
                              <font-awesome-icon icon="edit" />&nbsp;
                            </b-button>
                            <b-button
                              v-if="userSession === crm_sub_msg[index].create_by"
                              size="sm"
                              @click="delMsg(index)"
                              style="margin-left:5px; background-color:#005a7c"
                            >
                              <font-awesome-icon icon="trash" />&nbsp;
                            </b-button>
                          </b-col>
                          <b-col lg="12">
                            <b-form-textarea
                              v-model="crm_sub_msg[index].crm_sub_msg"
                              disabled
                              size="sm"
                              rows="2"
                            ></b-form-textarea>
                          </b-col>
                        </b-row>
                      </b-container>
                    </vue-custom-scrollbar>
                    <b-col lg="12" class="mt-4 mb-4 text-right">
                      <b-button size="sm" variant="danger" @click="closeModalCRM">ปิดหน้าต่าง</b-button>
                      <span class="m-1"></span>
                      <b-button size="sm" variant="success" @click="clickAddMsg">เพิ่มความเคลื่อนไหว</b-button>
                    </b-col>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal size="sm" title="เเจ้งเปลี่ยนเเปลงข้อมูล" hide-footer centered ref="modal-request">
      <b-container>
        <b-row class="mb-3">
          <b-col>
            รายละเอียดที่ต้องการเเก้ไข
            <span class="required">*</span>
            <b-form-textarea size="sm" ref="remark" v-model="remark"></b-form-textarea>
          </b-col>
        </b-row>
        <b-row class="text-center">
          <b-col>
            <b-button size="sm" variant="danger" @click="closeRequest">ยกเลิก</b-button>
            <span class="m-1"></span>
            <b-button size="sm" variant="success" @click="requestWorng">บันทึก</b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
    <b-modal
      size="xl"
      ref="modal-crm-data-only"
      title="การบริหารลูกค้าสัมพันธ์: CRM"
      centered
      hide-footer
    >
      <b-container class="text-left">
        <b-row>
          <b-col lg="3">
            <b-row class="head-title">
              <b-col>
                <h4 class="title-space-top">ข้อมูลบริษัท</h4>
              </b-col>
            </b-row>
            <b-row class="content-title border-box">
              <b-col lg="12" class="mt-2">บริษัท/ห้างหุ้นส่วน</b-col>
              <b-col lg="12">
                <b-form-textarea rows="2" size="sm" disabled v-model="crm.company_name"></b-form-textarea>
              </b-col>
              <b-col lg="12" class="mt-2">ที่อยู่</b-col>
              <b-col lg="12">
                <b-form-textarea rows="3" size="sm" disabled v-model="crm.address"></b-form-textarea>
              </b-col>
              <b-col lg="12" class="mt-2">เบอร์โทรศัพท์</b-col>
              <b-col lg="12">
                <b-form-input size="sm" disabled v-model="crm.tel"></b-form-input>
              </b-col>
              <b-col lg="12" class="mt-2">Line</b-col>
              <b-col lg="12">
                <b-form-input size="sm" disabled v-model="crm.line"></b-form-input>
              </b-col>
              <b-col lg="12" class="mt-2">Email</b-col>
              <b-col lg="12">
                <b-form-input size="sm" disabled v-model="crm.email"></b-form-input>
              </b-col>
              <b-col lg="12" class="mt-2">เลขประจำตัวผู้เสียภาษี</b-col>
              <b-col lg="12" class="mb-3">
                <b-form-input size="sm" disabled v-model="crm.taxno"></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="9">
            <b-row>
              <b-col>
                <b-row class="mb-4">
                  <b-col lg="12" class="head-title">
                    <h4 class="title-space-top">โครงการ</h4>
                  </b-col>
                  <b-col lg="12" class="content-title border-box">
                    <p class="m-3" style="font-size: 14px;">{{crm.project_name}}</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="text-left">
              <b-col>
                <b-row class="mb-4">
                  <b-col lg="12" class="head-title">
                    <h4 class="title-space-top">ความเคลื่อนไหว</h4>
                  </b-col>
                  <b-col lg="12" class="content-title border-box">
                    <vue-custom-scrollbar class="scroll-area" :settings="settings">
                      <b-container class="text-left">
                        <b-row class="mt-4" v-for="(msg, index) in crm_sub_msg" :key="index">
                          <b-col class="mb-2" lg="12" style="color: #005a7c">
                            <b>{{crm_sub_msg[index].create_datetime}}</b>&nbsp;&nbsp;|&nbsp;&nbsp;
                            <b>โดย {{crm_sub_msg[index].fullname}}</b>&nbsp;&nbsp;|&nbsp;&nbsp;
                            <span
                              v-if="crm_sub_msg[index].update_datetime !== null"
                              style="color: black; font-size: 10px;"
                            >(มีการเเก้ไข)</span>
                          </b-col>
                          <b-col lg="12">
                            <b-form-textarea
                              v-model="crm_sub_msg[index].crm_sub_msg"
                              disabled
                              size="sm"
                              rows="2"
                            ></b-form-textarea>
                          </b-col>
                        </b-row>
                      </b-container>
                    </vue-custom-scrollbar>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "./Footer";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import vueCustomScrollbar from "vue-custom-scrollbar";
import axios from "axios";
export default {
  components: { Navbar, Footer, VueGoodTable, vueCustomScrollbar },
  data() {
    return {
      name_select:null,
      search: {
        type: null,
        projectno: null,
        cust_name: null,
        follower: null,
        start_date: null,
        end_date: null
      },
      type_options: [{ value: null, text: "ทั้งหมด" }],
      column_list_bind: [
        {
          label: "เลขประจำตัวผู้เสียภาษี",
          field: "crm_bind_cust_taxno",
          sortable: false
        },
        {
          label: "บริษัท/ห้างหุ้นส่วนจำกัด",
          field: "ebidding_customer_name",
          sortable: false
        }
      ],
      row_list_bind: [],
      show_table_bind_search: false,
      company_search_bind: null,
      options_company: [],
      id_crm_sub_msg: null,
      userSession: null,
      crm_sub_msg: [],
      folower_options: [],
      folower_options_search: [],
      follower: null,
      dataSelect: null,
      row: [],
      checkaction: null,
      columns: [
        {
          label: "ประเภทลูกค้า",
          field: "crm_head_type",
          sortable: false,
          width: "9%"
        },
        {
          label: "บริษัท/ห้างหุ้นส่วน",
          field: "company_name",
          sortable: false,
          width: "14%"
        },
        {
          label: "ชื่อโครงการ",
          field: "project_name",
          sortable: false
        },
        {
          label: "เบอร์โทรศัพท์",
          field: "tel",
          sortable: false,
          width: "10%"
        },
        {
          label: "ผู้รับผิดชอบ",
          field: "fullname",
          sortable: false,
          width: "10%"
        },
        {
          label: "เครื่องมือ",
          field: "tool",
          sortable: false,
          width: "10%",
          tdClass: "text-center"
        }
      ],
      settings: {
        maxScrollbarLength: 60
      },
      check: false,
      status_options: [],
      crm: {
        id: null,
        project_name: null,
        company_name: null,
        address: null,
        tel: null,
        email: null,
        taxno: null,
        line: null,
        project_no: null
      },
      custno: null,
      projectSelect: null,
      form: {
        status: 1,
        msg: "",
        id: null,
        by: null,
        tel: null
      },
      remark: null,
      row_select_bind: [],
      column_select_bind: [
        {
          label: "เลขประจำตัวผู้เสียภาษี",
          field: "ebidding_customer_tax",
          sortable: false
        },
        {
          label: "บริษัท/ห้างหุ้นส่วนจำกัด",
          field: "ebidding_customer_name",
          sortable: false
        }
      ],
      company_name: null,
      update: {
        status: 1,
        msg: "",
        id: null
      }
    };
  },
  mounted() {
    axios.get("https://www.kmppartners.info:1009/api/ebidding/jobtype").then(res => {
      this.type_options = res.data.response;
    });
    axios
      .get("https://www.kmppartners.info:1009/api/ebidding/company_name")
      .then(res => {
        if (res.data.statusCompany) {
          for (let index = 0; index < res.data.response.length; index++) {
            this.options_company.push(
              res.data.response[index].ebidding_customer_name
            );
          }
        }
      });
    this.userSession = this.$session.get("username");
    axios.get("https://www.kmppartners.info:1009/api/get/crm_status").then(res => {
      if (res.data.status) {
        for (let index = 0; index < res.data.response.length; index++) {
          this.status_options.push(
            JSON.parse(
              '{"value":' +
                res.data.response[index].crm_status_id +
                ',"text":"' +
                res.data.response[index].crm_status_name +
                '"}'
            )
          );
        }
      }
    });
    axios.get("https://www.kmppartners.info:1009/api/get/crm/user").then(res => {
      if (res.data.status) {
        this.folower_options_search = [{ value: null, text: "" }];
        for (let index = 0; index < res.data.response.length; index++) {
          this.folower_options_search.push(
            JSON.parse(
              '{"text": "' +
                res.data.response[index].crm_sale_fullname +
                '", "value": "' +
                res.data.response[index].crm_sale_username +
                '"}'
            )
          );
          this.folower_options.push(
            JSON.parse(
              '{"text": "' +
                res.data.response[index].crm_sale_fullname +
                '", "value": "' +
                res.data.response[index].crm_sale_username +
                '"}'
            )
          );
        }
      }
    });
    axios.get("https://www.kmppartners.info:1009/api/get/crm_head").then(res => {
      if (res.data.status) {
        this.row = res.data.response;
      }
    });
  },
  methods: {
    closeRequest: function() {
      this.$refs["modal-request"].hide();
    },
    showRequest: function() {
      this.remark = null;
      this.$refs["modal-request"].show();
    },
    requestWorng: function() {
      if (this.remark !== null) {
        this.$bvModal
          .msgBoxConfirm(
            "ต้องการเเจ้งข้อมูลผิดของบริษัท/ห้างหุ้นส่วน " +
              this.crm.company_name +
              "หรือไม่",
            {
              title: "ต้องการดำเนินการต่อไหม?",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              cancelVariant: "danger",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
              okTitle: "ตกลง",
              cancelTitle: "ยกเลิก"
            }
          )
          .then(value => {
            if (value) {
              axios
                .post("https://www.kmppartners.info:1009/api/ebidding/add/request", {
                  ebidding_request_edit_projectno: this.crm.project_no,
                  ebidding_request_edit_customer_tax: this.crm.taxno,
                  ebidding_request_edit_remark: this.remark,
                  request_by: this.$session.get("username")
                })
                .then(res => {
                  if (res.data.status) {
                    axios.post("https://www.kmppartners.info:1009/api/notify/both", {
                      bearerSlack:
                        "xoxb-969680262326-1086010624482-XBrFyzCSqF2JFvaAeVfQfahv",
                      msg:
                        "มีการเเจ้งข้อมูลผิดของบริษัท/ห้างหุ้นส่วน " +
                        this.crm.company_name +
                        "โดย " +
                        this.userSession,
                      channelSlack: "เเจ้งปัญหา_ebidding",
                      bearerLine: "tvQ4ioaIiXfiUvp1XfeucZE7VYGNyC6KKdpnSDGCoXX"
                    });
                    axios
                      .post("https://www.kmppartners.info:1009/api/ebidding/access_log", {
                        access_username: this.$session.get("username"),
                        access_module:
                          "เเจ้งข้อมูลผิดพลาดของเลขประจำตัวผู้เสียภาษี " +
                          this.crm.taxno,
                        access_ipaddress: this.$session.get("ipaddress")
                      })
                      .then(rest => {
                        if (rest.data.statusLog) {
                          this.$bvModal
                            .msgBoxOk("ดำเนินการเรียบร้อย", {
                              title: "สำเร็จ",
                              size: "sm",
                              buttonSize: "sm",
                              okVariant: "success",
                              headerClass: "p-2 border-bottom-0",
                              footerClass: "p-2 border-top-0",
                              centered: true,
                              okTitle: "ตกลง"
                            })
                            .then(value => {
                              if (value) {
                                location.reload();
                              }
                            });
                        }
                      });
                  } else {
                    this.$bvToast.toast(res.data.error, {
                      title: "ผิดพลาด",
                      autoHideDelay: 3000,
                      appendToast: true,
                      variant: "danger"
                    });
                  }
                });
            }
          });
      } else {
        this.$bvToast.toast("กรุณากรอกข้อมูลรายละเอียดก่อน", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["remark"].focus();
      }
    },
    searchFn: function() {
      if (
        this.search.start_date === null &&
        this.search.end_date === null &&
        (this.search.projectno === null || this.search.projectno === "") &&
        (this.search.cust_name === null || this.search.cust_name === "") &&
        this.search.follower === null &&
        this.search.type === null
      ) {
        this.$bvToast.toast("กรุณาเลือกเงื่อนไขการค้นหาข้อมูล", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger"
        });
      } else if (
        this.search.start_date !== null &&
        this.search.end_date === null
      ) {
        this.$bvToast.toast("กรุณากรอกข้อมูลวันทีให้ครบ", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger"
        });
      } else if (
        this.search.end_date !== null &&
        this.search.start_date === null
      ) {
        this.$bvToast.toast("กรุณากรอกข้อมูลวันทีให้ครบ", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger"
        });
      } else {
        axios
          .post("https://www.kmppartners.info:1009/api/crm/search", this.search)
          .then(res => {
            if (res.data.status) {
              if (res.data.response === "ไม่พบข้อมูลที่ต้องการค้นหา") {
                this.$bvModal.msgBoxOk("ไม่พบข้อมูลที่ต้องการค้นหา", {
                  title: "สำเร็จ",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                  okTitle: "ตกลง"
                });
              } else {
                this.row = res.data.response;
                this.$refs["table-data-crm"].resetTable();
              }
            } else {
              this.$bvToast.toast(res.data.error, {
                title: "ผิดพลาด",
                autoHideDelay: 3000,
                appendToast: true,
                variant: "danger"
              });
            }
          });
      }
    },
    getListBind: function() {
      this.check = false;
      axios.get("https://www.kmppartners.info:1009/api/get/crm_bind").then(res => {
        if (res.data.status) {
          this.row_list_bind = res.data.response;
          this.check = true;
        } else {
          this.$bvToast.toast(res.data.error, {
            title: "ผิดพลาด",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "danger"
          });
        }
      });
    },
    clickDeleteListBind: function(params) {
      this.$bvModal
        .msgBoxConfirm(
          "ต้องการลบ" +
            params.row.ebidding_customer_name +
            "ออกจากรายการที่ไม่ต้องติดตามหรือไม่",
          {
            title: "ต้องการดำเนินการต่อไหม?",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            cancelVariant: "danger",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
            okTitle: "ตกลง",
            cancelTitle: "ยกเลิก"
          }
        )
        .then(value => {
          if (value) {
            axios
              .post("https://www.kmppartners.info:1009/api/del/crm_bind", {
                tax: params.row.crm_bind_cust_taxno
              })
              .then(res => {
                if (res.data.status) {
                  axios
                    .post("https://www.kmppartners.info:1009/api/ebidding/access_log", {
                      access_username: this.$session.get("username"),
                      access_module:
                        "ลบรายการบริษัท/ห้างหุ้นส่วนที่ไม่ต้องติดตาม",
                      access_ipaddress: this.$session.get("ipaddress")
                    })
                    .then(rest => {
                      if (rest.data.statusLog) {
                        this.$bvModal
                          .msgBoxOk("ดำเนินการเรียบร้อย", {
                            title: "สำเร็จ",
                            size: "sm",
                            buttonSize: "sm",
                            okVariant: "success",
                            headerClass: "p-2 border-bottom-0",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                            okTitle: "ตกลง"
                          })
                          .then(value => {
                            if (value) {
                              location.reload();
                            }
                          });
                      }
                    });
                }
              });
          }
        });
    },
    clickAddListBind: function(params) {
      this.$bvModal
        .msgBoxConfirm(
          "ต้องการเพิ่ม" +
            params.row.ebidding_customer_name +
            "เข้าในรายการที่ไม่ต้องติดตามหรือไม่",
          {
            title: "ต้องการดำเนินการต่อไหม?",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
            okTitle: "ตกลง",
            cancelTitle: "ยกเลิก",
            cancelVariant: "danger"
          }
        )
        .then(value => {
          if (value) {
            axios
              .post("https://www.kmppartners.info:1009/api/add/crm_bind", {
                tax: params.row.ebidding_customer_tax
              })
              .then(res => {
                if (res.data.status) {
                  axios
                    .post("https://www.kmppartners.info:1009/api/ebidding/access_log", {
                      access_username: this.$session.get("username"),
                      access_module:
                        "เพิ่มรายการบริษัท/ห้างหุ้นส่วนที่ไม่ต้องติดตาม",
                      access_ipaddress: this.$session.get("ipaddress")
                    })
                    .then(rest => {
                      if (rest.data.statusLog) {
                        this.$bvModal
                          .msgBoxOk("ดำเนินการเรียบร้อย", {
                            title: "สำเร็จ",
                            size: "sm",
                            buttonSize: "sm",
                            okVariant: "success",
                            headerClass: "p-2 border-bottom-0",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                            okTitle: "ตกลง"
                          })
                          .then(value => {
                            if (value) {
                              location.reload();
                            }
                          });
                      }
                    });
                }
              });
          }
        });
    },
    search_bind: function() {
      axios
        .post("https://www.kmppartners.info:1009/api/search_company/bind", {
          search: this.company_search_bind
        })
        .then(res => {
          if (res.data.status) {
            if (
              res.data.response ===
              "ไม่พบข้อมูลที่ตรงการ หรือ บริษัท/ห้างหุ้นส่วนจำกัดนี้อยู่ในรายการเเล้ว"
            ) {
              this.$bvModal.msgBoxOk(res.data.response, {
                title: "สำเร็จ",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
                okTitle: "ตกลง"
              });
            } else {
              this.row_select_bind = res.data.response;
              this.show_table_bind_search = true;
            }
          } else {
            this.$bvToast.toast(res.data.error, {
              title: "ผิดพลาด",
              autoHideDelay: 3000,
              appendToast: true,
              variant: "danger"
            });
          }
        });
    },
    changeSelect: function(e){
      axios.post('https://www.kmppartners.info:1009/api/get/fullname/' + e).then(res=>{
        if(res.data.status){
          this.name_select = res.data.name
        }
      })
    },
    openEditMsg: function(obj) {
      this.update.id = obj.crm_sub_id;
      this.update.msg = obj.crm_sub_msg;
      this.update.status = obj.crm_status_id;
      this.$refs["modal-msg-edit"].show();
    },
    closeModalCRM: function() {
      this.$refs["modal-crm-data"].hide();
    },
    closeFollwer: function() {
      this.$refs["modal-follower"].hide();
    },
    addFollwer: function(data, fn) {
      this.custno = data.company_tax;
      this.company_name = data.company_name;
      this.showModalFollower();
      this.projectSelect = data.project_no;
      this.dataSelect = data.crm_head_id;
      if (fn === "add") {
        this.checkaction = "add";
      } else {
        this.checkaction = "update";
      }
    },
    addFolloewer: function() {
      if (this.checkaction === "add") {
        if (this.follower !== null && this.follower !== "") {
          this.$bvModal
            .msgBoxConfirm(
              "ต้องการเพิ่มบุคคลนี้เป็นผู้ติดตามโครงการใช่หรือไม่",
              {
                title: "ต้องการดำเนินการต่อไหม?",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
                okTitle: "ตกลง",
                cancelTitle: "ยกเลิก",
                cancelVariant: "danger"
              }
            )
            .then(value => {
              if (value) {
                axios
                  .post("https://www.kmppartners.info:1009/api/add/follower", {
                    follower: this.follower,
                    by: this.$session.get("username"),
                    project: this.custno
                  })
                  .then(res => {
                    if (res.data.stauts) {
                      axios.post("https://www.kmppartners.info:1009/api/notify/both", {
                        bearerSlack:
                          "xoxb-969680262326-1086010624482-XBrFyzCSqF2JFvaAeVfQfahv",
                        channelSlack: "sale",
                        bearerLine:
                          "kaVXsMEcfhb0M5egq3ccIsMtWNjZHPjDKYNkjff9Nyk",
                        msg:
                          "\nโครงการของบริษัท/ห้างหุ้นส่วน " +
                          this.company_name +
                          " ได้มอบหมายให้กับ " +
                          this.name_select
                      });
                      axios.post("https://www.kmppartners.info:1009/api/crm/set/follower", {
                        who: this.follower,
                        id: this.custno
                      });
                      axios
                        .post("https://www.kmppartners.info:1009/api/ebidding/access_log", {
                          access_username: this.$session.get("username"),
                          access_module:
                            "เพิ่มผู้ติดตามโครงการ " + this.projectSelect,
                          access_ipaddress: this.$session.get("ipaddress")
                        })
                        .then(rest => {
                          if (rest.data.statusLog) {
                            this.$bvModal
                              .msgBoxOk("ดำเนินการเรียบร้อย", {
                                title: "สำเร็จ",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                                okTitle: "ตกลง"
                              })
                              .then(value => {
                                if (value) {
                                  location.reload();
                                }
                              });
                          }
                        });
                    } else {
                      this.$bvToast.toast(res.data.error, {
                        title: "ผิดพลาด",
                        autoHideDelay: 3000,
                        appendToast: true,
                        variant: "danger"
                      });
                    }
                  });
              }
            });
        } else {
          this.$bvToast.toast("กรุณาเลือกผู้รับผิดชอบก่อน", {
            title: "ผิดพลาด",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "danger"
          });
          this.$refs["follower"].focus();
        }
      } else if (this.checkaction === "update") {
        if (this.follower !== null && this.follower !== "") {
          this.$bvModal
            .msgBoxConfirm(
              "ต้องการเเก้ไขให้บุคคลนี้เป็นผู้ติดตามโครงการใช่หรือไม่",
              {
                title: "ต้องการดำเนินการต่อไหม?",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
                okTitle: "ตกลง",
                cancelTitle: "ยกเลิก",
                cancelVariant: "danger"
              }
            )
            .then(value => {
              if (value) {
                axios
                  .post("https://www.kmppartners.info:1009/api/update/follower", {
                    follower: this.follower,
                    by: this.$session.get("username"),
                    project: this.dataSelect
                  })
                  .then(res => {
                    if (res.data.status) {
                      axios.post("https://www.kmppartners.info:1009/api/notify/both", {
                        bearerSlack:
                          "xoxb-969680262326-1086010624482-XBrFyzCSqF2JFvaAeVfQfahv",
                        channelSlack: "sale",
                        bearerLine:
                          "kaVXsMEcfhb0M5egq3ccIsMtWNjZHPjDKYNkjff9Nyk",
                        msg:
                          "โครงการ " +
                          this.projectSelect +
                          " ของบริษัท/ห้างหุ้นส่วน " +
                          this.company_name +
                          " ได้เปลี่ยนผู้ติดตามโครงการเป็น " +
                          this.follower
                      });
                      axios
                        .post("https://www.kmppartners.info:1009/api/ebidding/access_log", {
                          access_username: this.$session.get("username"),
                          access_module:
                            "เเปลงเเปลงผู้ติดตามโครงการ " + this.projectSelect,
                          access_ipaddress: this.$session.get("ipaddress")
                        })
                        .then(rest => {
                          if (rest.data.statusLog) {
                            this.$bvModal
                              .msgBoxOk("ดำเนินการเรียบร้อย", {
                                title: "สำเร็จ",
                                size: "sm",
                                buttonSize: "sm",
                                okVariant: "success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                                okTitle: "ตกลง"
                              })
                              .then(value => {
                                if (value) {
                                  location.reload();
                                }
                              });
                          }
                        });
                    }
                  });
              }
            });
        } else {
          this.$bvToast.toast("กรุณาเลือกผู้รับผิดชอบก่อน", {
            title: "ผิดพลาด",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "danger"
          });
          this.$refs["follower"].focus();
        }
      }
    },
    showManageCust: function() {
      this.$refs["modal-config-crm"].show();
    },
    showModalFollower: function() {
      this.$refs["modal-follower"].show();
    },
    viewCRM: function(data) {
      this.crm.id = data.crm_head_id;
      this.crm.company_name = data.company_name;
      this.crm.project_name = data.project_name;
      this.crm.address = data.address;
      this.crm.tel = data.tel;
      this.crm.email = data.email;
      this.crm.taxno = data.company_tax;
      this.crm.line = data.line;
      this.crm.project_no = data.project_no;
      axios
        .post("https://www.kmppartners.info:1009/api/get/msg_crm", {
          id: this.crm.id
        })
        .then(res => {
          if (res.data.status) {
            this.crm_sub_msg = res.data.response;
          }
        });
      this.$refs["modal-crm-data"].show();
    },
    viewOnlyCRM: function(data) {
      axios.post("https://www.kmppartners.info:1009/api/ebidding/access_log", {
        access_username: this.$session.get("username"),
        access_module: "เข้าดูการติดตามโครงการโครงการ " + data.project_no,
        access_ipaddress: this.$session.get("ipaddress")
      });
      this.crm.project_no = data.project_no;
      this.crm.id = data.crm_head_id;
      this.crm.company_name = data.company_name;
      this.crm.project_name = data.project_name;
      this.crm.address = data.address;
      this.crm.tel = data.tel;
      this.crm.email = data.email;
      this.crm.taxno = data.company_tax;
      this.crm.line = data.line;
      axios
        .post("https://www.kmppartners.info:1009/api/get/msg_crm", {
          id: this.crm.id
        })
        .then(res => {
          if (res.data.status) {
            this.crm_sub_msg = res.data.response;
          } else {
            this.$bvToast.toast(res.data.error, {
              title: "ผิดพลาด",
              autoHideDelay: 3000,
              appendToast: true,
              variant: "danger"
            });
          }
        });
      this.$refs["modal-crm-data-only"].show();
    },
    closeMsgBox: function() {
      this.$refs["modal-msg-add"].hide();
    },
    closeMsgBoxEdit: function() {
      this.$refs["modal-msg-edit"].hide();
    },
    clickAddMsg: function() {
      this.$refs["modal-msg-add"].show();
    },
    addMsg: function() {
      axios.post('https://www.kmppartners.info:1009/api/get/fullname/' + this.userSession).then(res=>{
        if(res.data.status){
          this.name_select = res.data.name
        }
      })
      if (this.form.msg === null || this.form.msg === "") {
        this.$bvToast.toast("กรุณากรอกข้อความก่อน", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["msg"].focus();
      } else if (this.form.status === null || this.form.status === "") {
        this.$bvToast.toast("กรุณาเลือกประเภท", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["status"].focus();
      } else if (this.form.tel === null || this.form.tel === "") {
        this.$bvToast.toast("กรุณากรอกเบอร์โทรศัพท์", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["tel"].focus();
      } else {
        this.form.tel = this.form.tel.replace(/ /g, "");
        this.form.tel = this.form.tel.replace("+66", "0");
        this.form.tel = this.form.tel.replace(/-/g, "");
        this.form.tel = this.form.tel.replace(/\(/g, "");
        this.form.tel = this.form.tel.replace(/\)/g, "");
        axios.post("https://www.kmppartners.info:1009/api/change_tel", {
          tel: this.form.tel,
          by: this.$session.get("username"),
          tax_no: this.crm.taxno
        });
        this.form.by = this.$session.get("username");
        this.form.id = this.crm.id;
        this.$bvModal
          .msgBoxConfirm("ต้องการความเคลื่อนไหวของโครงการใช่หรือไม่", {
            title: "ต้องการดำเนินการต่อไหม?",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
            okTitle: "ตกลง",
            cancelTitle: "ยกเลิก",
            cancelVariant: "danger"
          })
          .then(value => {
            if (value) {
              axios
                .post("https://www.kmppartners.info:1009/api/add/msg_crm", this.form)
                .then(res => {
                  if (res.data.status) {
                    axios.post("https://www.kmppartners.info:1009/api/notify/both", {
                      bearerSlack:
                        "xoxb-969680262326-1086010624482-XBrFyzCSqF2JFvaAeVfQfahv",
                      channelSlack: "sale",
                      bearerLine: "kaVXsMEcfhb0M5egq3ccIsMtWNjZHPjDKYNkjff9Nyk",
                      msg:
                        "โครงการ " +
                        this.crm.project_no +
                        " ของบริษัท/ห้างหุ้นส่วน " +
                        this.crm.company_name +
                        " มีความเคลื่อนไหวเเล้วโดย " +
                        this.name_select
                    });
                    axios
                      .post("https://www.kmppartners.info:1009/api/ebidding/access_log", {
                        access_username: this.$session.get("username"),
                        access_module:
                          "เพิ่มข้อมูลความเคลื่อนไหวการติดตามงาน " +
                          this.crm.project_no,
                        access_ipaddress: this.$session.get("ipaddress")
                      })
                      .then(resta => {
                        if (resta.data.statusLog) {
                          location.reload();
                        }
                      });
                  } else {
                    this.$bvToast.toast(res.data.error, {
                      title: "ผิดพลาด",
                      autoHideDelay: 3000,
                      appendToast: true,
                      variant: "danger"
                    });
                  }
                });
            }
          });
      }
    },
    editMsg: function() {
      if (this.update.msg === null || this.update.msg === "") {
        this.$bvToast.toast("กรุณากรอกข้อความ", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["msg-update"].focus();
      } else if (this.update.status === null || this.update.status === "") {
        this.$bvToast.toast("กรุณาเลือกประเภท", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger"
        });
        this.$refs["status-update"].focus();
      } else {
        this.$bvModal
          .msgBoxConfirm("ต้องการเเก้ไขความเคลื่อนไหวใช่หรือไม่", {
            title: "ต้องการดำเนินการต่อไหม?",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
            okTitle: "ตกลง",
            cancelTitle: "ยกเลิก",
            cancelVariant: "danger"
          })
          .then(value => {
            if (value) {
              axios
                .post(
                  "https://www.kmppartners.info:1009/api/update/crm_sub_msg",
                  this.update
                )
                .then(res => {
                  if (res.data.status) {
                    this.$bvModal
                      .msgBoxOk("ดำเนินการเรียบร้อย", {
                        title: "สำเร็จ",
                        size: "sm",
                        buttonSize: "sm",
                        okVariant: "success",
                        headerClass: "p-2 border-bottom-0",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                        okTitle: "ตกลง"
                      })
                      .then(value => {
                        if (value) {
                          axios
                            .post(
                              "https://www.kmppartners.info:1009/api/ebidding/access_log",
                              {
                                access_username: this.$session.get("username"),
                                access_module:
                                  "เเก้ไขข้อมูลความเคลื่อนไหวการติดตามงาน " +
                                  this.crm.project_no,
                                access_ipaddress: this.$session.get("ipaddress")
                              }
                            )
                            .then(resta => {
                              if (resta.data.statusLog) {
                                location.reload();
                              }
                            });
                        }
                      });
                  } else {
                    this.$bvToast.toast(res.data.error, {
                      title: "ผิดพลาด",
                      autoHideDelay: 3000,
                      appendToast: true,
                      variant: "danger"
                    });
                  }
                });
            }
          });
      }
    },
    delMsg: function(idx) {
      this.$bvModal
        .msgBoxConfirm("ต้องการลบความเคลื่อนไหวใช่หรือไม่", {
          title: "ต้องการดำเนินการต่อไหม?",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
          okTitle: "ตกลง",
          cancelTitle: "ยกเลิก",
          cancelVariant: "danger"
        })
        .then(value => {
          if (value) {
            axios
              .post("https://www.kmppartners.info:1009/api/delete/del/crm_sup", {
                id: idx
              })
              .then(res => {
                if (res.data.status) {
                  this.$bvModal
                    .msgBoxOk("ดำเนินการเรียบร้อย", {
                      title: "สำเร็จ",
                      size: "sm",
                      buttonSize: "sm",
                      okVariant: "success",
                      headerClass: "p-2 border-bottom-0",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                      okTitle: "ตกลง"
                    })
                    .then(value => {
                      if (value) {
                        axios
                          .post(
                            "https://www.kmppartners.info:1009/api/ebidding/access_log",
                            {
                              access_username: this.$session.get("username"),
                              access_module:
                                "ลบข้อมูลความเคลื่อนไหวการติดตามงาน " +
                                this.crm.project_no,
                              access_ipaddress: this.$session.get("ipaddress")
                            }
                          )
                          .then(resta => {
                            if (resta.data.statusLog) {
                              location.reload();
                            }
                          });
                      }
                    });
                } else {
                  this.$bvToast.toast(res.data.error, {
                    title: "ผิดพลาด",
                    autoHideDelay: 3000,
                    appendToast: true,
                    variant: "danger"
                  });
                }
              });
          }
        });
    }
  }
};
</script>

<style>
.scroll-area {
  position: relative;
  margin: auto;
  width: 100%;
  height: 500px;
}
.border-box {
  border: 1px solid rgb(68, 68, 68);
  margin: 0px !important;
}
.box-crm {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
.crm {
  font-family: "K2D";
  margin: 2% !important;
  padding-bottom: 10%;
}
.table-crm .vgt-table.bordered th {
  background: #005a7c !important;
  color: white;
}
.box-crm .crm .container {
  max-width: 100% !important;
}
.head-title {
  background-color: #005a7c !important;
  margin: 0px !important;
  color: white !important;
}
.title-space-top {
  margin-top: 6px !important;
}

.tabs .nav-tabs .nav-link.active {
  color: white !important;
  background: #005a7c !important;
  border-radius: 10px;
}
.tabs .nav-tabs .nav-link:hover {
  color: white !important;
  background: #005a7c !important;
  border-radius: 10px;
}
.tabs .nav-tabs .nav-link {
  color: black !important;
}
</style>